import { SecretValue } from "client/Api/Apps/common";
import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export type NedapOnsConnectionListItemModel = {
	id: number;
	name: string;
	serverUrl: string;
};

export type NedapOnsConnectionModel = {
	id: number;
	name: string;
	serverUrl: string;
	clientCertificateFilename: string;
};

export type NedapOnsConnectionSaveModel = {
	name: string;
	serverUrl: string;
	clientCertificatePassword: SecretValue;
	clientCertificate: OptionalModel<Base64FileUriUploadModel>;
};

export type NedapOnsConnectionCreateResultModel = {
	connectionId: number;
};

export function list(
	signal?: AbortSignal
): Promise<ReadonlyArray<NedapOnsConnectionListItemModel>> {
	return httpClient.get<ReadonlyArray<NedapOnsConnectionListItemModel>>(
		"UiApi/NedapOnsConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<NedapOnsConnectionModel> {
	return httpClient.get<NedapOnsConnectionModel>(
		`UiApi/NedapOnsConfiguration/${id}`,
		undefined,
		{ signal }
	);
}

export function create(
	model: NedapOnsConnectionSaveModel,
	signal?: AbortSignal
): Promise<NedapOnsConnectionCreateResultModel> {
	return httpClient.post<NedapOnsConnectionCreateResultModel>(
		"UiApi/NedapOnsConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: NedapOnsConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.put<void>(
		`UiApi/NedapOnsConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteMultiple(
	ids: ReadonlyArray<number>,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.delete<void>(
		"UiApi/NedapOnsConfiguration",
		ids,
		{ signal }
	);
}
